import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
interface RatingProps {
  level: 1 | 2 | 3 | 4 | number;
  large?: boolean;
}

const Rating = ({ level, large }: RatingProps) => {
  const { t } = useTranslation('banks');
  return (
    <div className={cx('rating', { 'rating--lg': large })}>
      <div
        className={cx('rating__level', {
          'rating__level--1': level === 1,
          'rating__level--2': level === 2,
          'rating__level--3': level === 3,
          'rating__level--4': level === 4 || level === 5,
        })}
      >
        <div className="rating__num">{level}</div>
      </div>
      <div className="rating__col">
        <div className="rating__title">{t('score.title')}</div>
        <div className="rating__grade">{t(`score.grade.${level - 1}`)}</div>
      </div>
    </div>
  );
};

export default Rating;
